import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

import Login from '@/views/Login/index.vue';
import ResetPassword from '@/views/ResetPassword/index.vue';
import ManageRecentOrders from '@/views/ManageRecentOrders/index.vue';
import ForgotPassword from '@/views/ForgotPassword/index.vue';
import ResetForgotPassword from '@/views/ForgotPassword/ResetPassword.vue';

import StartOrder from '@/views/Order/StartOrder/index.vue';
import CreateOrder from '@/views/Order/CreateOrder/index.vue';
import TPNRegisterPatient from '@/views/Tpn/PatientRegister/index.vue';
import TPNCustomFormulation from '@/views/Tpn/CustomFormulation/index.vue';
import TPNCustomFormulationContact from '@/views/Tpn/CustomFormulation/contact.vue';
import TPNCustomFormulationCreate from '@/views/Tpn/CustomFormulationCreate/index.vue';
import SelectPatient from '@/views/Order/SelectPatient/index.vue';
import OrderDrugEdit from '@/views/Order/DrugDetail/DrugEdit.vue';
import DrugDetail from '@/views/Order/DrugDetail/index.vue';
import OrderDrugForm from '@/components/order/OrderDrug/OrderDrugForm.vue';
import OrderReviewComplete from '@/views/Order/ReviewComplete/index.vue';

import CsvUpload from '@/views/CsvUpload/index.vue';
import ReuseOrder from '@/views/ReuseOrder/index.vue';

import Home from '../views/Home/Home.vue';
import ManagePatient from '../views/ManagePatient/index.vue';
import EditPatient from '../views/ManagePatient/EditPatient.vue';
import ManageOrder from '../views/ManageOrder/index.vue';
import ManageSingleOrder from '../views/ManageSingleOrder/index.vue';
import Logout from '../views/Logout/index.vue';

// Test components for prototype build
import UI from '../views/UI.vue';

Vue.use(VueRouter);

const routes = [
  // User
  {
    name: 'login',
    path: '/login',
    component: Login,
    meta: {
      title: 'Login',
      requiresAuth: false,
    },
  },
  {
    name: 'samlassertion',
    path: '/samlassertion',
    component: Login,
    meta: {
      title: 'SAMLassertion',
      requiresAuth: false,
    },
  },
  {
    name: 'forgotPassword',
    path: '/forgot-password',
    component: ForgotPassword,
    meta: {
      title: 'Forgot Password',
      requiresAuth: false,
    },
  },
  {
    name: 'resetForgotPassword',
    path: '/forgot-password/reset',
    component: ResetForgotPassword,
    meta: {
      title: 'Forgot Password',
      requiresAuth: false,
    },
  },
  {
    name: 'resetPassword',
    path: '/user/reset-password',
    component: ResetPassword,
    meta: {
      title: 'Reset Password',
      requiresAuth: true,
    },
  },
  {
    name: 'manageRecentOrders',
    path: '/user/manage-recent-orders',
    component: ManageRecentOrders,
    meta: {
      title: 'Manage Recent Orders',
      requiresAuth: true,
    },
  },

  // Home/Dashboard
  {
    name: 'home',
    path: '/',
    component: Home,
    meta: {
      title: 'Home',
      requiresAuth: true,
    },
  },
  {
    name: 'homeTPN',
    path: '/tpn',
    component: Home,
    meta: {
      title: 'Home - TPN',
      requiresAuth: true,
    },
  },

  // Order
  {
    name: 'startOrder',
    path: '/order/start',
    component: StartOrder,
    meta: {
      title: 'Start Order',
      requiresAuth: true,
    },
  },
  {
    name: 'createOrder',
    path: '/order/create',
    component: CreateOrder,
    meta: {
      title: 'Create Order',
      requiresAuth: true,
    },
  },
  {
    name: 'createOrderTPN',
    path: '/tpn/order/create',
    component: CreateOrder,
    meta: {
      title: 'Create Order',
      requiresAuth: true,
    },
  },
  {
    name: 'TPNRegisterPatient',
    path: '/tpn/patient/register',
    component: TPNRegisterPatient,
    meta: {
      title: 'Register TPN Patient',
      requiresAuth: true,
    },
  },
  {
    name: 'TPNCustomFormulation',
    path: '/tpn/customFormulation',
    component: TPNCustomFormulation,
    meta: {
      title: 'Custom Formulations',
      requiresAuth: true,
    },
  },
  {
    name: 'TPNCustomFormulationContact',
    path: '/tpn/customFormulation/contact',
    component: TPNCustomFormulationContact,
    meta: {
      title: 'Custom Formulations - Contact',
      requiresAuth: true,
    },
  },
  {
    name: 'TPNCustomFormulationCreate',
    // path: '/tpn/customFormulationCreate',
    path: '/tpn/customFormulationCreate/:code?',
    component: TPNCustomFormulationCreate,
    meta: {
      title: 'New Custom Formulation',
      requiresAuth: true,
    },
  },
  {
    name: 'selectPatient',
    path: '/order/:orderId/select-patient',
    component: SelectPatient,
    meta: {
      title: 'Select Patient',
      requiresAuth: true,
    },
  },
  {
    name: 'selectPatientTPN',
    path: '/tpn/order/:orderId/select-patient',
    component: SelectPatient,
    meta: {
      title: 'Select Patient',
      requiresAuth: true,
    },
  },
  {
    name: 'drugDetail',
    path: '/order/:orderId/drug-detail/:patient?',
    component: DrugDetail,
    meta: {
      title: 'Drug Detail',
      requiresAuth: true,
    },
  },
  {
    name: 'drugDetailTPN',
    path: '/tpn/order/:orderId/drug-detail/:patient?',
    component: DrugDetail,
    meta: {
      title: 'Drug Detail',
      requiresAuth: true,
    },
  },
  {
    name: 'orderDrugForm',
    path: '/order/:orderId/order-drug-form/:patient?',
    component: OrderDrugForm,
    meta: {
      title: 'Drug Detail',
      requiresAuth: true,
    },
  },
  {
    name: 'editOrderDrug',
    path: '/order/:orderId/edit-drug',
    component: OrderDrugEdit,
    meta: {
      title: 'Edit Drug Detail',
      requiresAuth: true,
    },
  },
  {
    name: 'editOrderDrugTPN',
    path: '/tpn/order/:orderId/edit-drug',
    component: OrderDrugEdit,
    meta: {
      title: 'Edit Drug Detail',
      requiresAuth: true,
    },
  },
  {
    name: 'reviewComplete',
    path: '/order/:orderId/review-complete',
    component: OrderReviewComplete,
    meta: {
      title: 'Review Complete',
      requiresAuth: true,
    },
  },
  {
    name: 'reviewCompleteTPN',
    path: '/tpn/order/:orderId/review-complete',
    component: OrderReviewComplete,
    meta: {
      title: 'Review Complete',
      requiresAuth: true,
    },
  },
  {
    name: 'manageOrders',
    path: '/manage-orders',
    component: ManageOrder,
    meta: {
      title: 'Manage Orders',
      requiresAuth: true,
    },
  },
  {
    name: 'manageTpnOrders',
    path: '/tpn/manage-orders',
    component: ManageOrder,
    meta: {
      title: 'Manage Nutrition Orders',
      requiresAuth: true,
    },
  },
  {
    name: 'manageSingleOrder',
    path: '/order/:orderId/manage',
    component: ManageSingleOrder,
    meta: {
      title: 'Manage Order',
      requiresAuth: true,
    },
  },
  {
    name: 'manageSingleOrderTPN',
    path: '/tpn/order/:orderId/manage',
    component: ManageSingleOrder,
    meta: {
      title: 'Manage Order',
      requiresAuth: true,
    },
  },

  // Patient
  {
    name: 'managePatients',
    path: '/manage-patient',
    component: ManagePatient,
    meta: {
      title: 'Manage Patient',
      requiresAuth: true,
    },
  },
  {
    name: 'editPatient',
    path: '/patient/:id/edit',
    component: EditPatient,
    meta: {
      title: 'Edit Patient',
      requiresAuth: true,
    },
  },

  {
    name: 'csvUpload',
    path: '/csv',
    component: CsvUpload,
    meta: {
      title: 'Upload Csv',
      requiresAuth: true,
    },
  },
  {
    name: 'reuseOrder',
    path: '/csv',
    component: ReuseOrder,
    meta: {
      title: 'Reuse Order',
      requiresAuth: true,
    },
  },
  {
    name: 'logout',
    path: '/user/logout',
    component: Logout,
    meta: {
      requiresAuth: true,
    },
  },

  // testing/temp routes
  {
    path: '/ui',
    component: UI,
    meta: {
      requiresAuth: false,
    },
  },
];

const router = new VueRouter({
  store,
  routes,
});

router.beforeEach(async (to, from, next) => {
  document.title = `${to.meta.title} | BOLT | Baxter Compounding` || 'Application | BOLT | Baxter Compounding';
  await store
    .dispatch('IS_AUTHENTICATED')
    .then((response) => {
      if (to.meta.requiresAuth === true && response === false) {
        next({ name: 'login' });
      } else if (to.meta.requiresAuth === false && response === true) {
        next({ name: 'home' });
      } else {
        next();
      }
    });
});

export default router;
